import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import {
    calculatedPageNumberText,
    getScaledPageDimensions,
    isMobilePortrait,
} from '../catalogHelpers';
import get from 'lodash.get';
import styles from '../styles/catalogPageNumber.scss';
import commonStyles from '../styles/catalogCommon.scss';
import { DESKTOP, TABLET, MOBILE } from '../../utils/deviceType';

export const CatalogPageNumberComponent = ({
    catalogPage,
    currentPage,
    deviceType,
    isPageRight,
    mobileScale,
    scale,
    screenOrientation,
    tabletScale,
    zoomedIn,
}) => {
    const singlePageDimensions = get(catalogPage, 'images.singlePageDimensions');
    const pageCount = get(catalogPage, 'images.pageCount');
    const isPhonePortrait = isMobilePortrait(deviceType, screenOrientation);
    let currScale = scale;

    if (deviceType === TABLET) {
        currScale = tabletScale;
    } else if (deviceType === MOBILE) {
        currScale = mobileScale;
    }

    const scaledPageDimensions = getScaledPageDimensions(
        currentPage,
        pageCount,
        singlePageDimensions,
        currScale
    );
    let displayedPageWidth = scaledPageDimensions.width + 'px';

    if (isPhonePortrait) {
        displayedPageWidth = 'auto';
    }

    if (zoomedIn || (!isPhonePortrait && !scaledPageDimensions.width)) {
        return null;
    }

    return (
        <div
            className={classNames({
                [styles.pageNumber]: true,
                [styles.pageNumberMobilePortrait]: isPhonePortrait,
                [commonStyles.proximaBold]: true,
            })}
            style={{
                width: displayedPageWidth,
            }}
        >
            {calculatedPageNumberText(currentPage, pageCount, isPhonePortrait, isPageRight)}
        </div>
    );
};

CatalogPageNumberComponent.propTypes = {
    catalogPage: PropTypes.object,
    currentPage: PropTypes.number,
    deviceType: PropTypes.string,
    isPageRight: PropTypes.bool,
    margin: PropTypes.number,
    mobileScale: PropTypes.number,
    scale: PropTypes.number,
    screenOrientation: PropTypes.string,
    tabletScale: PropTypes.number,
    zoomedIn: PropTypes.bool,
};

CatalogPageNumberComponent.defaultProps = {
    deviceType: DESKTOP,
};

const mapStateToProps = state => {
    return {
        currentPage: state.ui.currentPage,
        isPageRight: state.ui.isPageRight,
        margin: state.ui.margin,
        mobileScale: state.ui.mobileScale,
        scale: state.ui.scale,
        screenOrientation: state.ui.screenOrientation,
        tabletScale: state.ui.tabletScale,
        zoomedIn: state.ui.zoomedIn,
    };
};

export const CatalogPageNumber = createFragmentContainer(
    connect(mapStateToProps)(CatalogPageNumberComponent),
    {
        catalogPage: graphql`
            fragment CatalogPageNumber_catalogPage on CatalogPage {
                images {
                    pageCount
                    singlePageDimensions {
                        height
                        width
                    }
                }
            }
        `,
    }
);
